import React from 'react';
import MainFilterPanels from '@client/components/search/MainFilterPanels';
import ExtraFilters from '@client/feature/treatment/components/Search/Filters/ExtraFilters';
import { useFilterPanels } from '@client/hooks/useFilterPanels';
import { EXTRA_FILTER_KEYS } from '@client/feature/treatment/config/filterConfigs';
import SearchIcon from '../../../../img/search-icon.svg';
import AddFiltersIcon from '../../../../img/add_filters.svg';
import UpIcon from '../../../../img/collapse-icon-up.svg';

// eslint-disable-next-line react/display-name
const ExpandIcon = React.memo(({ isActive }) => (
  <img
    src={UpIcon}
    alt="Toggle"
    style={{
      width: '24px',
      height: '24px',
      transition: 'transform 0.3s ease',
      transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
    }}
  />
));

const FilterPanels = ({ filters, onFilterChange, aggregations, filterLabels }) => {
  const { extraCount, defaultActiveKeys } = useFilterPanels(
    filters,
    [],
    EXTRA_FILTER_KEYS
  );

  return (
    <MainFilterPanels
      ExtraFiltersComponent={ExtraFilters}
      filters={filters}
      onFilterChange={onFilterChange}
      extraCount={extraCount}
      defaultActiveKeys={defaultActiveKeys}
      ExpandIcon={ExpandIcon}
      icons={{ search: SearchIcon, addFilters: AddFiltersIcon }}
      aggregations={aggregations}
      filterLabels={filterLabels}
    />
  );
};

export default React.memo(FilterPanels);
